
document.addEventListener("DOMContentLoaded", function(){

  const tabs = document.querySelectorAll(".sg-tab");
  const letters = document.querySelectorAll(".sg-letter");
  const items = document.querySelectorAll(".sg-item");

  let activeTab = "all";
  let activeLetter = "all";

  function filterItems(){
    items.forEach(item => {
      const itemTab = item.dataset.tab;
      const itemLetter = item.dataset.letter;

      const tabMatch = activeTab === "all" || itemTab === activeTab;
      const letterMatch = activeLetter === "all" || itemLetter === activeLetter;

      if(tabMatch && letterMatch){
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  }

  tabs.forEach(tab => {
    tab.addEventListener("click", function(){
      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");
      activeTab = this.dataset.tab;
      filterItems();
    });
  });

  letters.forEach(letter => {
    letter.addEventListener("click", function(){
      letters.forEach(l => l.classList.remove("active"));
      this.classList.add("active");
      activeLetter = this.dataset.letter;
      filterItems();
    });
  });

});
